/* eslint-disable react/no-unused-state */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pushNotification from 'helpers/pushnotification/pushnotification';
/**
 * Uncomment it to enable Popup Manager
 */
// import { popupManager } from 'utils/popupManager';
import WithCubeAd from 'modules/WithCubeAd/WithCubeAd';
import { isPrimeNotActive } from 'utils/primeUtil';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import _get from 'lodash.get';
import WithAdBlockerDetector from 'components_v2/common/AdBlockerDetector/WithAdBlockerDetector';
import PrimePaymentFlowCaller from 'components/PrimePaymentFlow/PrimePaymentFlowCaller';
import AlreadyPrimeToastLoader from 'components/PrimeMessages/AlreadyPrimeToastLoader';
import PrimeWelcomePopupLoader from 'components/PrimeWelcomePopup/PrimeWelcomePopupLoader';
import FloatingOpenInApp from 'components_v2/common/FloatingOpenInApp/FloatingOpenInApp';
import OpenInAppBottomWidget from 'components_v2/common/OpenInAppBottomWidget/OpenInAppBottomWidget';

import { appendScriptToHead } from 'utils/DOMUtils';
import VideoModalLoader from 'components_v2/mobile/VideoModal/VideoModalLoader';
import WithMiniTv from 'modules/WithMiniTv/WithMiniTv';
import { initiateLocateService, getIbeatContentType } from 'utils/common';
// import { isGoogleBot } from 'utils/common';
import Cookie, { setCookie, getCookie } from 'utils/cookies';
/**
 * BreakingNews not in use, none of the APIs are giving data
 * https://toibnews.timesofindia.indiatimes.com/Election/election2017_breakingnews.htm
 * https://timesofindia.indiatimes.com/feed_breakingnews/feedtype-json.cms
 */
// import BreakingNews from 'components_v2/mobile/BreakingNews';
// import WithBreakingNews from 'modules/WithBreakingNews';
import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen/PrimeScreenLoader';
import { loadGeoData, loadGeoLocationData } from 'reduxUtils/modules/geo';
import {
  loadTranslationData,
  loadNudgeData,
} from 'reduxUtils/modules/translationConfig';
import { loadGdprData } from 'reduxUtils/modules/gdpr';
import {
  loadToiPlusConfig,
  loadUpdatedToiPlusConfig,
} from 'reduxUtils/modules/toiPlusConfig';
import miniTvStyle from 'components/MiniTvV2/UsPageMiniTvTheme.scss';
import { loadAllAdsFromQueue } from 'helpers/ads/redux';
// import ConsentForm from 'components/Login/ConsentFormLoader';
// import LinksList from 'components_v2/mobile/LinksList';
import AdCaller from 'helpers/ads/adCaller';
import AtfAd from 'helpers/ads/AtfAd';

import { setSaleNudgeVisibility } from 'reduxUtils/modules/affiliates';
import { setIbeattrack } from 'utils/iBeatConfig';
/**
 * None of the nudges are being called thorugh popupManager
 * Not in Use through popupManager, not even being called with showforcenudge:true
 * Enable it and load it lazily when required
 */
// import WithPopup from 'modules/WithPopup';
// import AdFreeNudge from 'components/AdFreeNudge/';
// import TimesTop10Loader from 'components/TimesTop10/TimesTop10Loader';
// import Covid19 from 'components/Covid19SubscriptionWdt';
import WithWebViewLoginHook from 'components_v2/common/WebViewLoginHook/WithWebViewLoginHook';
import AdCube from 'components_v2/common/AdCube';
import BreadCrumb from 'components_v2/common/BreadCrumb/BreadCrumb';
import ElectionLiveBlogs from 'components_v2/common/ElectionLiveBlogs';
import ToiplusFooter from 'components_v2/common/ToiplusFooter/ToiplusFooter';
import { updateMwebOpenSearchStatus } from 'routes/articleshow_v2/redux';
import AffiliatesContentV2 from 'components/AffiliatesContentV2';
import adBlockPromise from 'components_v2/common/AdBlockerDetector/AdBlockDetectUtils';
import {
  removeScrollListener,
  pageAmountScrolled,
  initiateOptInNotification,
  showNotificationPrompt,
} from 'utils/notification';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { GEOAPI_URL } from '../../../constants';
import s from './Layout.scss';
import Header from '../Header';
import Footer from '../Footer';
import StickyFooterWidgets from '../StickyFooterWidgets';

// eslint-disable-next-line no-unused-vars, import/extensions
import grxlocalStorage from '../../../components_library/utils/grxUtil/grxLocalStorageUtil.js';

// const Covid19LoaderWithPopup = WithPopup(Covid19);
// const TimesTop10LoaderWithPopup = WithPopup(TimesTop10Loader);
// const AdfreeNudgeWithPopup = WithPopup(AdFreeNudge);
// const GenderPopupLoaderWithPopup = WithPopup(GenderPopupLoader);

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCustomSubscription: false,
      isCustomPopupVisibleOnce: false,
      currentHref: '',
      isPropensityApiTriggered: false,
    };
    this.analticsScriptLoaded = false;
    if (typeof window !== 'undefined') {
      window.adBlockerEventSentOnce = false;
    }
  }

  componentDidMount() {
    const { isWapView } = this.props.params;
    const {
      isNotificationPopupEnabled,
      templateName,
      isPrime,
      pageType,
    } = this.props;
    window.times = window.times || {};
    window.times.cookie = window.times.cookie || {};
    window.times.cookie.set = this.setCookie;
    const { geoinfo = {} } = window;
    if (typeof window.geoinfo === 'object') {
      initiateLocateService(() => {
        this.props.loadGeoData(window.geoinfo);
        this.props.loadGeoLocationData();
      });
    } else {
      initiateLocateService(() => {
        appendScriptToHead({
          scriptUrl: GEOAPI_URL,
          callback: this.props.loadGeoLocationData,
        });
      });
    }
    // this.props.loadGeoLocationData();
    this.props.loadGdprData();
    this.loadAnalyticsScript();
    this.props.loadAllAdsFromQueue('', window.location.pathname);
    // popupManager(
    //   undefined,
    //   true,
    //   this.props.popGeoConfig.mweb,
    //   this.props.disablePopUpManager,
    // );
    pushNotification.init({
      template: templateName,
      pageType,
      isPrime,
    });
    // window.showAdFreeNudge = this.showForceNudge;
    this.props.loadToiPlusConfig(
      this.props.isPrime,
      isWapView,
      geoinfo.Continent,
      geoinfo.region_code,
      geoinfo.CountryCode,
    );
    this.props.loadTranslationData(isWapView, geoinfo.CountryCode);
    this.props.loadTOIPlusNudgeData(isWapView, geoinfo.CountryCode);

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.checkUtmCookie(params);
    // Mounting of entrire page component is done, hence throwing event.
    // if somethings to be be performed
    const layoutMountDone = new Event('PAGE_MOUNTED');
    window.dispatchEvent(layoutMountDone);
    if (this.props.hideAdBlockerDetector) {
      adBlockPromise.then(() => {});
    }
    if (
      isNotificationPopupEnabled &&
      isNotificationPopupEnabled.mweb &&
      isNotificationPopupEnabled.mweb.enabled &&
      isNotificationPopupEnabled.mweb.enabled === '1' &&
      !getCookie('customLaterClick') &&
      showNotificationPrompt()
    ) {
      this.setState(
        {
          currentHref: window.location.href,
        },
        () => {
          this.initiateCustomSubscription();
        },
      );
    }

    setIbeattrack({
      contentType: getIbeatContentType(
        this.props?.pageType,
        this.props?.isphotostory,
      ),
    });
  }

  initiateCustomSubscription = () => {
    const { pageType, msid } = this.props;

    if (
      pageType.toLowerCase() === 'home' ||
      pageType.toLowerCase() === 'listing' ||
      pageType.toLowerCase() === 'newslisting' ||
      pageType.toLowerCase() === 'photolist'
    ) {
      setTimeout(() => {
        if (!getCookie('notificationNotSupported')) {
          this.setState({
            showCustomSubscription: true,
          });
        }
      }, 5000);
    }
    window.addEventListener(
      'scroll',
      () => {
        const showCustomPopup = pageAmountScrolled(
          pageType,
          msid,
          this.state.currentHref,
        );
        if (showCustomPopup && !getCookie('customLaterClick')) {
          if (!getCookie('notificationNotSupported')) {
            this.setState(prevState => ({
              showCustomSubscription: true,
              isCustomPopupVisibleOnce:
                prevState.currentHref !== window.location.href &&
                !(
                  pageType.toLowerCase() === 'home' ||
                  pageType.toLowerCase() === 'listing' ||
                  pageType.toLowerCase() === 'newslisting' ||
                  pageType.toLowerCase() === 'photolist'
                )
                  ? false
                  : prevState.isCustomPopupVisibleOnce,
              currentHref: window.location.href,
            }));
          }
        }
      },
      { passive: true },
    );
  };

  closeCustomSubscriptionPopup = isLaterClicked => {
    this.setState({
      showCustomSubscription: false,
      isCustomPopupVisibleOnce: true,
    });
    if (isLaterClicked) {
      setCookie('customLaterClick', 'yes', 1, '/');
      const { headerData, pageType } = this.props;
      const sectionName =
        headerData &&
        headerData.navigation &&
        headerData.navigation.breadcrumbs &&
        headerData.navigation.breadcrumbs.length &&
        headerData.navigation.breadcrumbs.length >= 2
          ? headerData.navigation.breadcrumbs[1].label
          : '';
      sendGaThroughProps({
        data: {
          gaCategory: 'Notification_Opt-in',
          gaAction: 'Clicked_Later',
          gaLabel: `${
            pageType.toLowerCase() === 'home' ? 'Home' : sectionName
          }-${pageType}`,
        },
      });
    }
  };

  enableIzootoCall = () => {
    initiateOptInNotification();
    this.setState({
      showCustomSubscription: false,
      isCustomPopupVisibleOnce: true,
    });
    const { headerData, pageType } = this.props;
    const sectionName =
      headerData &&
      headerData.navigation &&
      headerData.navigation.breadcrumbs &&
      headerData.navigation.breadcrumbs.length &&
      headerData.navigation.breadcrumbs.length >= 2
        ? headerData.navigation.breadcrumbs[1].label
        : '';
    sendGaThroughProps({
      data: {
        gaCategory: 'Notification_Opt-in',
        gaAction: 'Clicked_Allow',
        gaLabel: `${
          pageType.toLowerCase() === 'home' ? 'Home' : sectionName
        }-${pageType}`,
      },
    });
  };

  componentWillUnmount() {
    removeScrollListener();
    // initiateLocateService();
  }

  // showForceNudge = () => {
  //   this.setState({ showforcenudge: true });
  // };

  setCookie = (name, value, days, path, domain, secure) => {
    const updatedDomain =
      domain === '.indiatimes.com' ? '.timesofindia.com' : domain;
    Cookie.set(name, value, days, path, updatedDomain, secure);
  };

  checkUtmCookie = params => {
    if (Object.keys(params).length !== 0 && params.constructor === Object) {
      const cookieName = params.utm_source ? Cookie.get(params.utm_source) : '';
      if (cookieName == null) {
        const date = new Date();
        date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
        const expires = `; expires=${date.toGMTString()}`;
        document.cookie = `utm_source=${params.utm_source};${expires}`;
        if (params.utm_source === 'admitad') {
          document.cookie = `utm_source_id=${params.admitad_uid};${expires}`;
          document.cookie = `utm_admitad_expires=${date};${expires}`;
        } else {
          document.cookie =
            'utm_source_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        }
      } else if (params.utm_source === 'admitad') {
        const cookieVal = Cookie.get(params.admitad_uid);
        if (cookieVal == null) {
          const cookieexpire = `; expires=${Cookie.get('utm_admitad_expires')}`;
          document.cookie = `utm_source_id=${
            params.admitad_uid
          };${cookieexpire}`;
        }
      }
    }
  };

  loadAnalyticsScript() {
    if (!this.analticsScriptLoaded) {
      window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
        if (
          !dataObj.isEUuser ||
          (dataObj.isEUuser && dataObj.didUserOptOut === false) ||
          dataObj.userRegion === 'CA'
        ) {
          const script = document.createElement('script');
          script.setAttribute(
            'src',
            'https://static.clmbtech.com/ase/2658/39/aa.js',
          );
          script.setAttribute('async', 'async');
          document.body.appendChild(script);
          this.analticsScriptLoaded = true;
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    this.loadAnalyticsScript();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.checkUtmCookie(params);
    if (
      prevProps.userPrcData !== this.props.userPrcData &&
      this.props.isPrime
    ) {
      this.props.loadUpdatedToiPlusConfig(
        this.props.isPrime,
        this.props.renewNudgeCloseDuration,
      );
    }
  }

  shouldShowAdFreeNudge = prcValue => {
    let shouldShow = false;
    if (typeof window === 'object' && isPrimeNotActive(prcValue)) {
      shouldShow = true;
    }
    return shouldShow;
  };

  getTopSearches = (topicSeoKeywords, topSearches) => {
    if (
      topicSeoKeywords &&
      topicSeoKeywords.items &&
      Array.isArray(topicSeoKeywords.items) &&
      topicSeoKeywords.items.length > 0
    ) {
      return {
        data: topicSeoKeywords.items,
      };
    }
    if (topSearches && topSearches.items && topSearches.items.length > 0) {
      return {
        ...topSearches,
        data: [...topSearches.items],
      };
    }
    return undefined;
  };
  render() {
    const {
      query,
      params,
      skipAds,
      skipFooter,
      mobileATFAdCode,
      mobileFBNAdCode,
      footerFanAdData,
      l1Sections,
      showTOIPlus,
      showShortLogo,
      headerData,
      hideAds,
      hideTopSearch,
      headerLabel,
      showBreadcrumb,
      hideLogoMastHead,
      layoutClass,
      searchKeyword,
      toipLayout,
      isSearchOpenedFrmMidArticle,
      hideFooterAdMargin,
      hideAffiliatesFloatingNudge = true,
      setSaleNudgeVisibilityFn,
      topicSeoKeywords,
      userData,
      layoutType,
      isAffiliatePage,
      mastheadText,
      isMastHeadH1,
      breadCrumbTitle,
      hasOutsidePlanFooter,
      removeOneTap,
      l2Sections,
      stickyContentSupport,
      userPrcData,
      inContentAtfAD,
      hideOpenInAppFloatingButton = false,
      isReviewsPage,
      pageType = '',
    } = this.props;
    const grxId = Cookie.get('_grx');
    const isMinitvActive = this.props.showMiniTv;

    const { isWapView } = params;
    const frmapp = query.frmapp === 'yes' || query.frmapp === 'shorts';
    const prcValue =
      userData && userData.prcValue ? this.props.userData.prcValue : 0;
    const atfAdCodeObject =
      mobileATFAdCode && mobileATFAdCode.adCode
        ? mobileATFAdCode
        : _get(this.props, 'commonData.atfAd');
    const fbnAdCodeObject =
      mobileFBNAdCode && mobileFBNAdCode.adCode
        ? mobileFBNAdCode
        : _get(this.props, 'commonData.fbnAd');
    const fanFbnAdCodeObject =
      footerFanAdData && footerFanAdData.placementId
        ? footerFanAdData
        : _get(this.props, 'commonData.fbnFanAd');
    const headerSlugAdCodeObject = _get(this.props, 'commonData.headerSlugAd');
    let breadCrumb = _get(
      this.props,
      'headerData.navigation.breadcrumbs',
      undefined,
    );
    if (this.props.BreadcrumbList && this.props.BreadcrumbList.length > 0) {
      breadCrumb = this.props.BreadcrumbList;
    }
    const overlayAtfad = _get(this.props, 'commonData.overlayAtfad');
    const overlayMrecAd = _get(this.props, 'commonData.overlayMrecAd');
    const overlayMrecAd1 = _get(this.props, 'commonData.overlayMrecAd1');
    const overlayFBNAd = _get(this.props, 'commonData.fbnAd');
    const topSearches = _get(this.props, 'commonData.topSearches');
    const underToneAd = _get(this.props, 'commonData.underTone');

    const topSearchesKeywords = this.getTopSearches(
      topicSeoKeywords,
      topSearches,
    );
    return (
      <div className={`${frmapp ? 'appView' : 'nonAppView'} ${layoutClass}`}>
        {/* // for business section only */}
        {this.props.pageType === 'Home' &&
          !this.props.isAppView &&
          prcValue === 5 && (
            <LoadableComponentLoader
              loadableComponentName="SubscriptionStripWrapper"
              isWapView={isWapView}
              userPrcData={userPrcData}
              isAppView={this.props.isAppView}
            />
          )}
        {(this.props.pageType === 'Home' ||
          this.props.pageType === 'toiplusarticleshow' ||
          this.props.pageType === 'ARTICLESHOW') && <div id="portal-modal" />}
        {/* sale nudge commented */}
        {!hideAffiliatesFloatingNudge && (
          <AffiliatesContentV2
            type="toi_widget_slots_v2"
            client="affiliates"
            loadingComponent={<></>}
            // enableWidgetsOnLoad
            filters={{
              pagename: pageType.toLowerCase(),
            }}
            onContentLoaded={() => {
              setSaleNudgeVisibilityFn(true);
            }}
            noShowCallback={() => {
              setSaleNudgeVisibilityFn(false);
            }}
            initOnPageLoad
          />
        )}
        {!hideOpenInAppFloatingButton &&
          !frmapp &&
          (!toipLayout &&
            (this.props.pageType === 'Home' ||
              // this.props.pageType === 'LIVEBLOG' ||
              this.props.pageType === 'ARTICLESHOW') && (
              <FloatingOpenInApp
                // loadOnScroll
                msid={this.props.msid}
                subSecSeoLocation={this.props.subSecSeoLocation}
                pageType={this.props.pageType}
                useStaticUrl={this.props.useStaticOpenAppUrl}
                grxId={grxId}
              />
            ))}
        {!toipLayout &&
          this.props.pageType === 'ARTICLESHOW' && (
            <OpenInAppBottomWidget
              msid={this.props.msid}
              subSecSeoLocation={this.props.subSecSeoLocation}
              pageType={this.props.pageType}
              useStaticUrl={this.props.useStaticOpenAppUrl}
              grxId={grxId}
            />
          )}
        {!this.props.isPrime &&
          !this.props.params.hideMobileTopBar &&
          !this.props.hideAdCude &&
          !skipAds &&
          !frmapp && <AdCube isWapView={isWapView} />}
        {/* {this.props.showCovid19PopUp &&
          !this.props.covid19StickyView && (
            <Covid19LoaderWithPopup popupView={1} />
          )} */}
        {/* {!isGoogleBot() && (
          <TimesTop10LoaderWithPopup popupView={1} isWapView />
        )} */}
        {/* <GenderPopupLoaderWithPopup isWapView /> */}
        {/* {!frmapp && this.getPrimeWidgets()} */}
        {!frmapp && (
          <React.Fragment>
            {!hideTopSearch && topSearchesKeywords && <div />}
            <Header
              headerData={this.props.headerData}
              hideL2Navigation={this.props.hideL2Navigation}
              hideOpenInAppTopWidget={this.props.hideOpenInAppTopWidget}
              openappUrl={this.props.openappUrl || this.props.openInAppDll}
              isCountrySwitchWidget={this.props.isCountrySwitchWidget}
              currentCountry={this.props.currentCountry}
              l1Sections={l1Sections}
              l2Sections={l2Sections}
              showTOIPlus={showTOIPlus}
              showShortLogo={showShortLogo}
              hideLogoMastHead={hideLogoMastHead}
              underToneAd={underToneAd}
              userData={this.props.userData}
              hideAds={hideAds}
              geolocation={this.props.geolocation}
              gaCategory={this.props.gaCategory}
              headerType={this.props.headerType}
              headerLabel={headerLabel}
              showToiPlusEntryPoints={this.props.showToiPlusEntryPoints}
              searchKeyword={searchKeyword}
              isSearchOpenedFrmMidArticle={isSearchOpenedFrmMidArticle}
              updateMwebOpenSearchStatus={this.props.updateMwebOpenSearchStatus}
              disableTimesPointWidget={this.props.disableTimesPointWidget}
              pageType={this.props.pageType}
              layoutType={this.props.layoutType}
              toipLayout={this.props.toipLayout}
              showHeaderOnScroll={this.props.showHeaderOnScroll}
              hideStickyL2Nav={this.props.hideStickyL2Nav}
              isAffiliatePage={isAffiliatePage}
              msid={this.props.msid}
              articleSectionData={this.props.articleSectionData}
              newsData={this.props.newsData}
              liveblogData={this.props.liveblogData}
              isLiveblogListing={this.props.isLiveblogListing}
              mastheadText={mastheadText}
              isMastHeadH1={isMastHeadH1}
              isWapView={isWapView}
              // OpenInAppTopBandWidget={this.props.OpenInAppTopBandWidget}
              removeOneTap={removeOneTap}
              headerSlugAdCodeObject={headerSlugAdCodeObject}
              enableHeaderUnificationVersion={
                this.props.enableHeaderUnificationVersion
              }
              disableCityNavBreakdown={this.props.disableCityNavBreakdown}
              isUsHomePage={this.props.isUsHomePage}
              isVideoshowPage={this.props.isVideoshowPage}
              mastheadImageLogo={this.props.mastheadImageLogo}
              subSecSeoLocation={this.props.subSecSeoLocation}
              isReviewsPage={isReviewsPage}
              skipReloadForPrimeLogin={this.props.skipReloadForPrimeLogin}
            />
          </React.Fragment>
        )}
        {this.props.pageType === 'Home' && (
          <PrimeScreen
            componentName="TopBand"
            theme="white_theme"
            isWapView={isWapView}
          />
        )}
        {isMinitvActive &&
          !frmapp && (
            <WithMiniTv
              isWapView
              styleObject={miniTvStyle}
              showMiniTvSection={this.props.showMiniTvSection}
              donotShiftMiniTv={this.props.donotShiftMiniTv}
              wrapperClass={this.props.miniTvWrapperClass}
              minitvMwebInPage={this.props.minitvMwebInPage}
            />
          )}

        {!hideAds &&
          !inContentAtfAD &&
          atfAdCodeObject &&
          !this.props.isPrime &&
          !skipAds && (
            <AtfAd msid={this.props.msid} atfAdCodeObject={atfAdCodeObject} />
          )}
        {/* <WithBreakingNews customComponent={BreakingNews} /> */}
        <div
          className={`contentwrapper clearfix 
          ${stickyContentSupport ? 'stickyContentSupport' : ''}
          ${this.props.layoutType || ' '}`}
          data-sticky-target="atf"
          ref={contentElement => {
            this.rhsElement = contentElement;
          }}
        >
          {this.props.children}
          {!frmapp &&
            !this.props.isPrime &&
            !skipAds &&
            !this.props.params.hideMobileTopBar && (
              <WithCubeAd
                pageType={this.props.pageType}
                isWapView={isWapView}
              />
            )}
        </div>
        {!hideAds &&
          headerData &&
          headerData.sitesync && (
            <AdCaller
              deviceType="mobile"
              data={{
                ...headerData.sitesync,
              }}
              immediateLoad
            />
          )}
        {/* {commonData &&
          commonData.geoAd && (
            <AdCaller
              immediateLoad
              data={commonData.geoAd}
              deviceType="mobile"
              cookieKey="geolocation"
            />
          )} */}
        {!this.props.isPrime &&
          !hideAds &&
          !skipAds &&
          this.props.lastMrecAd &&
          !toipLayout && (
            <div
              className="ad_spacing"
              data-translate-id="cw"
              key="ad_endofarticle"
            >
              <AdCaller
                deviceType="mobile"
                data={{
                  name: 'endofarticle',
                  ...this.props.lastMrecAd,
                }}
              />
            </div>
          )}
        {this.props?.footerData?.electionLiveblogsWidget?.items &&
          Array.isArray(this.props?.footerData.electionLiveblogsWidget.items) &&
          this.props?.footerData.electionLiveblogsWidget.items.length > 0 && (
            <div className="electionLiveBlogsWrapper">
              <ElectionLiveBlogs
                sectionData={this.props?.footerData.electionLiveblogsWidget}
                isWapView
              />
            </div>
          )}
        {this.props.pageType.toLowerCase() === 'home' && (
          <div
            className={`${s.default_h1} ${s.bgOffWhite}`}
            data-translate-id="cw"
          >
            <span>THE TIMES OF INDIA / </span>
            <strong>TOP</strong>&nbsp;
            <h1>News</h1>
          </div>
        )}
        {showBreadcrumb &&
          typeof breadCrumb !== 'undefined' && (
            <div className="breadcrumbmobile" data-translate-id="cw">
              {breadCrumbTitle && breadCrumbTitle !== '' ? (
                <BreadCrumb
                  data={breadCrumb}
                  wrapperClass="breadcrumb"
                  title={breadCrumbTitle}
                />
              ) : (
                <BreadCrumb data={breadCrumb} wrapperClass="breadcrumb" />
              )}
            </div>
          )}
        {!skipFooter && (
          <Footer
            footerData={this.props.footerData}
            params={this.props.params}
            isWapView={isWapView}
            frmapp={frmapp}
            fbnAdCodeObject={fbnAdCodeObject}
            fanFbnAdCodeObject={fanFbnAdCodeObject}
            footerWithOnlyFbn={params.hideMobileTopBar}
            hideFbn={this.props.hideFbn}
            // mobileFBNAdClass={this.props.mobileFBNAdClass}
            refreshFBNAd={this.props.refreshFBNAd}
            // pageType={this.props.pageType}
            currentCountry={this.props.currentCountry}
            hideAds={hideAds || skipAds}
            isPrivateUser={this.props.isPrivateUser}
            useContentVisibilty={this.props.useContentVisibilty}
            hideFooterAdMargin={hideFooterAdMargin}
            msid={this.props.msid}
            articleSectionData={this.props.articleSectionData}
            newsData={this.props.newsData}
            liveblogData={this.props.liveblogData}
            breadCrumb={breadCrumb}
          />
        )}
        {!skipFooter && (
          <StickyFooterWidgets
            footerData={this.props.footerData}
            frmapp={frmapp}
            fbnAdCodeObject={fbnAdCodeObject}
            footerWithOnlyFbn={params.hideMobileTopBar}
            hideFbn={this.props.hideFbn}
            hideBackToTop={this.props.hideBackToTop}
            hideAds={hideAds || skipAds}
          />
        )}
        {skipFooter &&
          !hasOutsidePlanFooter &&
          toipLayout &&
          this.props?.footerData && (
            <ToiplusFooter footerData={this.props.footerData} />
          )}
        <WithWebViewLoginHook frmapp={frmapp} />
        <PrimePaymentFlowCaller />
        <LoadableComponentLoader
          loadOnScroll={this.props.pageType === 'ARTICLESHOW' && !toipLayout}
          loadableComponentName="ToiSubscriptionLoader"
          userData={this.props.userData}
          isWapView={isWapView}
          query={query}
          currencyCode={_get(this.props.translationData, 'currencyCode', '')}
          msid={this.props.msid}
          storyTitle={this.props.storyTitle}
        />
        {userPrcData &&
          !userPrcData?.gstAddressUpdateRequired && (
            <>
              <PrimeWelcomePopupLoader
                isWapView={isWapView}
                userPrcData={userPrcData}
              />
              <AlreadyPrimeToastLoader
                userData={userData}
                toipLayout={toipLayout}
                layoutType={layoutType}
                isPrime={this.props.isPrime}
                msid={this.props.msid}
                storyTitle={this.props.storyTitle}
                userPrcData={userPrcData}
              />
            </>
          )}
        {/* <WithVideoOverlay rhsref={this.rhsElement} /> */}
        {!this.props.hideAdBlockerDetector &&
          !(
            this.props.hideAdBlockerConfig &&
            this.props.hideAdBlockerConfig === '1'
          ) &&
          !this.props.toipLayout &&
          !this.props.isPrime &&
          !skipAds && <WithAdBlockerDetector />}
        {this.props.isModalOpen && (
          <VideoModalLoader
            adsData={{
              atfAd: overlayAtfad,
              mrecAds: [overlayMrecAd, overlayMrecAd1],
              fbnAd: overlayFBNAd,
            }}
            showFBN={this.props.showFBNInVideoModal}
            path={this.props.path}
          />
        )}
        {/* {this.props.userData &&
          this.props.userData.showConsentPopUp && (
            <ConsentForm isPrivateUser={this.props.isPrivateUser} overlayView />
          )} */}
        {/* {this.state.showCustomSubscription &&
        !this.state.isCustomPopupVisibleOnce ? (
          <div ref={this.customPromptRef}>
            <LoadableComponentLoader
              loadOnScroll
              loadableComponentName="CustomNotificationPrompt"
              clickEnable={this.enableIzootoCall}
              closePopup={this.closeCustomSubscriptionPopup}
              template={this.props.pageType}
              isPrime={this.props.isPrime}
              sectionName={
                headerData &&
                headerData.navigation &&
                headerData.navigation.breadcrumbs &&
                headerData.navigation.breadcrumbs.length &&
                headerData.navigation.breadcrumbs.length >= 2
                  ? headerData.navigation.breadcrumbs[1].label
                  : ''
              }
            />
          </div>
        ) : (
          ''
        )} */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  isSearchOpenedFrmMidArticle: _get(
    state,
    'articleshow_v2.isSearchOpenedFrmMidArticle',
    false,
  ),
  isPrivateUser: state.gdpr.isPrivateUser,
  // adsQueueData: state.adCaller.adsQueueData,
  adsCampaignStatus: state.adCaller.adsCampaignStatus,
  userData: state.login.userData,
  currentCountry: _get(state, 'geo.currentCountry', undefined),
  headerData: state.header.data,
  footerData: state.footer_v2.data,
  commonData: state.commonData && state.commonData.data,
  isModalOpen: _get(state, 'videoModal.isModalOpen'),

  openappUrl:
    state.navigation && state.navigation.openappUrl
      ? state.navigation.openappUrl
      : '',
  showToiPlusEntryPoints: _get(
    state,
    'toiplusconfig.showToiPlusEntryPoints',
    false,
  ),
  showToiPlusNudges: state.toiplusconfig?.showToiPlusNudges,
  translationData: _get(state, 'translationConfig.data', {}),
  popGeoConfig: _get(state, 'common.siteConfig.popup', {
    mweb: {
      enabled: 0,
      geo: {
        IN: '1',
        US: '1',
        ROW: '1',
      },
    },
  }),
  hideAdBlockerConfig: _get(state, 'common.siteConfig.hideAdBlocker', '0'),
  openSearch: !!state.openSearch,
  articleSectionData: state.articleshow_v2?.data,
  newsData: state.newslisting && state.newslisting.data,
  liveblogData: state.liveblog_v2,
  isNotificationPopupEnabled: _get(state, 'common.siteConfig.notification', {
    mweb: {
      enabled: '1',
    },
  }),
  userPrcData: state.login.userPrcData,
  renewNudgeCloseDuration: _get(
    state,
    'translationConfig.nudges.unifiedNodes.preExpiry.renewNudgeCloseDuration',
    24,
  ),
});

const mapDispatchToProps = dispatch => ({
  loadAllAdsFromQueue: (params, path) => {
    dispatch(loadAllAdsFromQueue(params, path));
  },
  loadGdprData: params => {
    dispatch(loadGdprData(params));
  },
  loadGeoData: params => {
    dispatch(loadGeoData(params));
  },
  loadGeoLocationData: params => {
    dispatch(loadGeoLocationData(params));
  },
  loadToiPlusConfig: (
    isPrime,
    isWapView,
    currentContinent,
    currentRegion,
    currentCountry,
  ) => {
    dispatch(
      loadToiPlusConfig(
        isPrime,
        isWapView,
        currentContinent,
        currentRegion,
        currentCountry,
      ),
    );
  },
  loadUpdatedToiPlusConfig: (isPrime, renewNudgeCloseDuration) => {
    dispatch(loadUpdatedToiPlusConfig(isPrime, renewNudgeCloseDuration));
  },
  loadTranslationData: (isWapView, currentCountry) => {
    dispatch(loadTranslationData(isWapView, currentCountry));
  },
  updateMwebOpenSearchStatus: () => {
    dispatch(updateMwebOpenSearchStatus(false));
  },
  loadTOIPlusNudgeData: (isWapView, currentCountry) => {
    dispatch(loadNudgeData(isWapView, currentCountry));
  },
  setSaleNudgeVisibilityFn: status => {
    dispatch(setSaleNudgeVisibility(status));
  },
});

Layout.propTypes = {
  isPrime: PropTypes.bool.isRequired,
  pageType: PropTypes.string,
  subSecSeoLocation: PropTypes.string,
  children: PropTypes.node.isRequired,
  query: PropTypes.shape({}).isRequired,
  translationData: PropTypes.shape({}),
  params: PropTypes.shape({
    fullPath: PropTypes.string.isRequired,
    hideMobileTopBar: PropTypes.bool,
    liveblogHeader: PropTypes.bool,
    refreshAtfAd: PropTypes.bool,
    isWapView: PropTypes.bool,
  }).isRequired,
  userData: PropTypes.shape({
    showConsentPopUp: PropTypes.bool,
  }),
  loadGdprData: PropTypes.func.isRequired,
  loadGeoData: PropTypes.func.isRequired,
  loadGeoLocationData: PropTypes.func.isRequired,
  loadAllAdsFromQueue: PropTypes.func.isRequired,
  layoutType: PropTypes.string,
  // hideStickyBackToTop: PropTypes.bool,
  mobileAdCode: PropTypes.shape({}),
  mobileFBNAdCode: PropTypes.shape({}),
  showMiniTv: PropTypes.bool,
  showMiniTvSection: PropTypes.string,
  refreshFBNAd: PropTypes.bool,
  hideAdBlockerDetector: PropTypes.bool,
  hideAdBlockerConfig: PropTypes.string,
  isPrivateUser: PropTypes.bool,
  currentCountry: PropTypes.string,
  headerData: PropTypes.shape({
    sitesync: PropTypes.shape({}),
  }),
  commonData: PropTypes.shape({}),
  footerData: PropTypes.shape({}),
  isModalOpen: PropTypes.bool,
  hideL2Navigation: PropTypes.bool,
  hideOpenInAppTopWidget: PropTypes.bool,
  mobileATFAdCode: PropTypes.shape({}),
  footerFanAdData: PropTypes.shape({}),
  fbnAdsData: PropTypes.shape({}),
  skipAds: PropTypes.bool,
  openappUrl: PropTypes.string,
  skipFooter: PropTypes.bool,
  isCountrySwitchWidget: PropTypes.bool,
  hideBackToTop: PropTypes.bool,
  showFBNInVideoModal: PropTypes.bool,
  l1Sections: PropTypes.arrayOf(PropTypes.shape({})),
  l2Sections: PropTypes.arrayOf(PropTypes.shape({})),
  showTOIPlus: PropTypes.bool,
  showShortLogo: PropTypes.bool,
  hideFbn: PropTypes.bool,
  hideAds: PropTypes.bool,
  hideTopSearch: PropTypes.bool,
  geolocation: PropTypes.string,
  // showCovid19PopUp: PropTypes.bool,
  // covid19StickyView: PropTypes.bool,
  gaCategory: PropTypes.string,
  openInAppDll: PropTypes.string,
  // categoryForGA: PropTypes.string,
  headerType: PropTypes.string,
  headerLabel: PropTypes.string,
  loadToiPlusConfig: PropTypes.func.isRequired,
  loadUpdatedToiPlusConfig: PropTypes.func.isRequired,
  loadTranslationData: PropTypes.func.isRequired,
  showToiPlusEntryPoints: PropTypes.bool,
  useContentVisibilty: PropTypes.bool,
  showBreadcrumb: PropTypes.bool,
  hideLogoMastHead: PropTypes.bool,
  // showToiPlusNudges: PropTypes.bool,
  // disablePopUpManager: PropTypes.bool,
  layoutClass: PropTypes.string,
  hideAdCude: PropTypes.bool,
  donotShiftMiniTv: PropTypes.bool,
  miniTvWrapperClass: PropTypes.string,
  BreadcrumbList: PropTypes.arrayOf(PropTypes.shape({})),
  disableTimesPointWidget: PropTypes.bool,
  hideFooterAdMargin: PropTypes.bool,
  isSearchOpenedFrmMidArticle: PropTypes.bool,
  searchKeyword: PropTypes.string,
  hideAffiliatesFloatingNudge: PropTypes.bool,
  msid: PropTypes.number,
  storyTitle: PropTypes.string,
  topicSeoKeywords: PropTypes.shape({}),
  toipLayout: PropTypes.bool,
  showHeaderOnScroll: PropTypes.bool,
  hideStickyL2Nav: PropTypes.bool,
  isAffiliatePage: PropTypes.bool,
  setSaleNudgeVisibilityFn: PropTypes.func.isRequired,
  isNotificationPopupEnabled: PropTypes.shape({}),
  isLiveblogListing: PropTypes.bool,
  mastheadText: PropTypes.string,
  isMastHeadH1: PropTypes.bool,
  breadCrumbTitle: PropTypes.string,
  removeOneTap: PropTypes.bool,
  stickyContentSupport: PropTypes.bool,
  hideOpenInAppFloatingButton: PropTypes.bool,
  enableHeaderUnificationVersion: PropTypes.bool,
  disableCityNavBreakdown: PropTypes.bool,
  isUsHomePage: PropTypes.bool,
  isVideoshowPage: PropTypes.bool,
  lastMrecAd: PropTypes.shape({}),
  minitvMwebInPage: PropTypes.bool,
  renewNudgeCloseDuration: PropTypes.number,
  inContentAtfAD: PropTypes.bool,
};

Layout.defaultProps = {
  pageType: '',
  userData: undefined,
  translationData: {},
  layoutType: '',
  headerType: '',
  headerLabel: '',
  // hideStickyBackToTop: false,
  hideFbn: false,
  mobileAdCode: undefined,
  mobileFBNAdCode: undefined,
  commonData: {},
  //adsCampaignStatusUrl: undefined,
  //hideBreadcrumAtBottom: false,
  //mobileFBNAdClass: '',
  showMiniTv: false,
  showMiniTvSection: '',
  refreshFBNAd: false,
  hideAdBlockerDetector: false,
  hideAdBlockerConfig: '0',
  //pageType: '',
  subSecSeoLocation: '',
  isPrivateUser: true,
  currentCountry: undefined,
  headerData: undefined,
  footerData: undefined,
  isModalOpen: undefined,
  hideL2Navigation: false,
  hideOpenInAppTopWidget: true,
  mobileATFAdCode: {},
  footerFanAdData: {},
  fbnAdsData: {},
  skipAds: false,
  openappUrl: '',
  skipFooter: false,
  isCountrySwitchWidget: false,
  hideBackToTop: false,
  showFBNInVideoModal: false,
  l1Sections: [],
  l2Sections: [],
  showTOIPlus: false,
  showShortLogo: false,
  hideAds: false,
  hideTopSearch: false,
  geolocation: '1',
  minitvMwebInPage: false,
  // showCovid19PopUp: false,
  // covid19StickyView: false,
  gaCategory: undefined,
  openInAppDll: '',
  // categoryForGA: '',
  showToiPlusEntryPoints: false,
  useContentVisibilty: false,
  showBreadcrumb: false,
  hideLogoMastHead: false,
  // showToiPlusNudges: false,
  // disablePopUpManager: false,
  layoutClass: '',
  hideAdCude: false,
  donotShiftMiniTv: false,
  miniTvWrapperClass: '',
  BreadcrumbList: undefined,
  disableTimesPointWidget: false,
  hideFooterAdMargin: false,
  isSearchOpenedFrmMidArticle: false,
  searchKeyword: '',
  hideAffiliatesFloatingNudge: false,
  msid: '',
  storyTitle: '',
  topicSeoKeywords: {},
  toipLayout: false,
  showHeaderOnScroll: false,
  hideStickyL2Nav: false,
  isAffiliatePage: false,
  isNotificationPopupEnabled: {},
  isLiveblogListing: false,
  mastheadText: '',
  isMastHeadH1: true,
  breadCrumbTitle: '',
  removeOneTap: false,
  stickyContentSupport: false,
  hideOpenInAppFloatingButton: false,
  enableHeaderUnificationVersion: false,
  disableCityNavBreakdown: false,
  isUsHomePage: false,
  isVideoshowPage: false,
  lastMrecAd: null,
  renewNudgeCloseDuration: 24,
  inContentAtfAD: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
